import { render, staticRenderFns } from "./ShoppingCartControl.vue?vue&type=template&id=564c7b45"
import script from "./ShoppingCartControl.vue?vue&type=script&lang=js"
export * from "./ShoppingCartControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports